// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import {
  MdDesktopWindows,
  MdLocalLaundryService,
  MdDirectionsBus,
  MdMyLocation,
  MdSchool,
  MdCenterFocusStrong,
  MdMyLocation,
} from 'react-icons/md';
import { FaUniversity, FaPizzaSlice } from 'react-icons/fa';
import ClipLoader from "react-spinners/ClipLoader"

import OverlayContext from './context/OverlayContext';
import { laundretteList } from './data/laundrettes';
import Card from './Card';

interface ICard {
  type: 'laundry' | 'buses' | 'pcs' | 'outlets';
  selector: string;
}

const Button = {
  flex: '0 0 auto',
  display: 'flex',
  alignItems: 'center',
  padding: '8px 8px',
  boxShadow: '0 0 4px 1px rgba(0, 0, 0, 0.25)',
  borderRadius: '4px',
  marginRight: '8px',
  border: '0',
  backgroundColor: 'white',
  fontSize: '18px',
  pointerEvents: 'auto',
};

const Overlay: React.FC<{ loading: any }> = ({ loading }) => {
  const {
    id,
    mapReady,
    mapRef,
    buses,
    pcs,
    laundry,
    setMarkers,
    location,
    outlets,
    search,
  } = useContext(OverlayContext);
  const [selected, setSelect] = useState<
    'buses' | 'laundry' | 'pcs' | 'outlets' | null
  >(null);
  const [card, setCard] = useState<ICard | null>(null);

  const select = (item: string) => {
    if (selected === item) {
      setSelect(null);
    } else {
      setSelect(item);
    }
  };

  useEffect(() => {
    setCard(null);
  }, [selected])

  useEffect(() => {
    if (selected === null) {
      setMarkers([]);
    }

    if (selected === 'laundry') {
      let laundretteArray = [];
      for (const [key, value] of Object.entries(laundretteList)) {
        laundretteArray.push({ ...value, key });
      }

      setMarkers(
        laundretteArray.map(laundrette => {
          return {
            colour: 'MazeBlue',
            location: { lat: laundrette.lat, lng: laundrette.lng },
            title: laundrette.key,
            onClick: () =>
              setCard({ type: 'laundry', selector: laundrette.key }),
          };
        })
      );
    }

    if (selected === 'pcs') {
      setMarkers(
        pcs.room.map(pc => {
          return {
            colour: 'MazeGreen',
            location: { lng: pc.gpslon, lat: pc.gpslat },
            title: pc.location,
            onClick: () => setCard({ type: 'pcs', selector: pc.rid }),
          };
        })
      );
    }

    if (selected === 'buses') {
      setMarkers(
        buses.map(stop => {
          return {
            colour: 'MazeOrange',
            location: { lng: stop.longitude, lat: stop.latitude },
            title: stop.commonName,
            onClick: () => setCard({ type: 'buses', selector: stop.atcoCode }),
          };
        })
      );
    }

    if (selected === 'outlets') {
      setMarkers(
        outlets.map(outlet => {
          return {
            colour: outlet.isOpen ? 'MazeGreen' : 'MazeRed',
            location: { lng: outlet.longitude, lat: outlet.latitude },
            title: outlet.name,
            onClick: () =>
              setCard({ type: 'outlets', selector: outlet.businessID }),
          };
        })
      );
    }
  }, [selected, buses]);

  const flyToCampus = () => {
    if (!mapRef?.current) return;
    mapRef.current.flyTo({
      center: { lng: -2.7856, lat: 54.00908 },
      zoom: 16,
      speed: 1,
    });
  };

  const flyToMe = () => {
    if (!mapRef?.current) return;
    mapRef.current.flyTo({
      center: location,
      zoom: 17,
      speed: 1,
    });
  };

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: search ? 50 : 0,
          left: 0,
          width: '100%',
          padding: '10px',
          overflowX: 'auto',
          display: 'flex',
        }}
      >
        <button
          style={{
            ...Button,
            backgroundColor: selected === 'buses' ? '#3098fc' : '#FFF',
            color: selected === 'buses' ? '#FFF' : '#000',
          }}
          onClick={() => select('buses')}
          disabled={!buses}
        >
          <MdDirectionsBus size={18} />
          <div style={{ marginLeft: '5px', display: "flex", alignContent: "center", alignItems: "center" }}>
            Buses
            {loading.buses && selected === 'buses' ? <div style={{ marginLeft: '10px', display: 'flex', alignContent: "center", alignItems: "center" }}><ClipLoader color="#FFF" loading={true} size={15} /></div> : null}
          </div>
        </button>

        <button
          style={{
            ...Button,
            backgroundColor: selected === 'pcs' ? '#3098fc' : '#FFF',
            color: selected === 'pcs' ? '#FFF' : '#000',
          }}
          onClick={() => select('pcs')}
          disabled={!pcs}
        >
          <MdDesktopWindows size={18} />
          <span style={{ marginLeft: '5px' }}>PCs</span>
        </button>

        <button
          style={{
            ...Button,
            backgroundColor: selected === 'laundry' ? '#3098fc' : '#FFF',
            color: selected === 'laundry' ? '#FFF' : '#000',
          }}
          onClick={() => select('laundry')}
          disabled={!laundry}
        >
          <MdDesktopWindows size={18} />
          <span style={{ marginLeft: '5px' }}>Laundry</span>
        </button>

        <button
          style={{
            ...Button,
            backgroundColor: selected === 'outlets' ? '#3098fc' : '#FFF',
            color: selected === 'outlets' ? '#FFF' : '#000',
          }}
          onClick={() => select('outlets')}
          disabled={!outlets}
        >
          <FaPizzaSlice size={18} />
          <span style={{ marginLeft: '5px' }}>Outlets</span>
        </button>
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          padding: '10px',
          display: 'flex',
          flexDirection: 'column',
          zIndex: '50',
        }}
      >
        <button
          style={{
            ...Button,
            cursor: location ? "pointer" : "default",
            padding: 15,
            marginBottom: 10,
            opacity: location ? 1 : 0.5,
          }}
          onClick={() => location ? flyToMe() : null}
        >
          <MdMyLocation size={22} />
        </button>
        <button
          style={{ ...Button, cursor: 'pointer', padding: 15 }}
          onClick={flyToCampus}
        >
          <FaUniversity size={22} />
        </button>
      </div>

      {card && <Card selector={card.selector} type={card.type} />}
    </>
  );
};

export default Overlay;
